import { Tabs } from "antd";
import type { TabsProps } from "antd";

export type UITabProps = {
  value?: string | number;
  label?: string;
};

export type UITabsProps = Omit<TabsProps, "onChange" | "items"> & {
  value?: string | number;
  onChange?: (_event: unknown, value: string | number) => void;
  items?: TabsProps["items"];
};

export const UITabs = ({ value, onChange, ...props }: UITabsProps) => (
  <Tabs
    activeKey={value !== undefined ? String(value) : undefined}
    onChange={(key) => onChange?.(undefined, key)}
    {...props}
  />
);

export const UITab = (_props: UITabProps) => null;
